export default {
    shops: state =>  state.shops.data,
    shopsSearched: state =>  state.shopsSearched.data,
    current: state =>  state.current.data,
    current_shop_id: state =>  state.current.data.oid,
    products: state =>  state.products,
    services: state =>  state.services,
    options: state =>  state.current.data.options,
    productsfilterSelected: state =>  state.productsfilterSelected
}


//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/shops/getters.js
// module id = null
// module chunks = 